import Axios from '../config/axios';

export function modifyEducationHistory(postdata) {
    return Axios.post(`/api/ModifyEducationHistory`, postdata
    ).then(response => response.data).catch(error => error);
}